const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
//@core
const { formatText } = require('core/i18n').i18n;

//@utilities
const { formatAmount, formatCurrency, decimalsLength, getFormattedString } = require('utilities/currencyHelper');

//@commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const OKCalculationWaffer = require('components/commons/OKCalculationWaffer/OKCalculationWaffer');

// @constants
const { PERCENTAGE_SYMBOL } = require('constants/index');

class PayrollLoanCalculationCard extends React.Component {

    addPercentage(value) {
        return formatAmount(value, 2).concat(' ', PERCENTAGE_SYMBOL);
    }

    buildTae() {
        const { taeTooltip, tae } = this.props;
        const formattedTae = this.addPercentage(tae);

        const taeItem = {
            title: formatText('contractPayrollLoanStepOne-TAE'),
            bodyText: formattedTae,
        }

        if (taeTooltip) {
            taeItem.icon = 'icon-informacion';
            taeItem.tooltipPlacement = 'right';
            taeItem.tooltipModifier = 'dark-bg';
            taeItem.tooltipAlternativeIcon = true
            taeItem.tooltipClassName = 'contract-payroll-loan-step-one__tooltip';
            taeItem.iconCustomClass = 'contract-payroll-loan-step-one__tae-icon';
            taeItem.tooltipOffset = [10, 0];
            taeItem.information = taeTooltip;
        }

        return taeItem;
    }

    render() {
        const { tin, currency, arrangementFee, installment, arrangementPercentage, nodata } = this.props;

        const formattedCurrency = formatCurrency(currency);
        const formattedInstallment = nodata ? formatText('contractLoanCompilationCard-nodata') : getFormattedString(installment);
        const formattedTin = this.addPercentage(tin);
        const decimalsArragementFee = decimalsLength(arrangementFee);
        const formattedArrangementFee = formatAmount(arrangementFee, decimalsArragementFee);
        const taeItem = this.buildTae();

        const values = [
            {
                title: formatText('contractPayrollLoanStepOne-anualTin'),
                bodyText: formattedTin
            },
            taeItem,
            {
                title: formatText('contractPayrollLoanStepOne-arrangementFee', [arrangementPercentage]),
                bodyText: `${formattedArrangementFee} ${formattedCurrency}`
            }
        ];

        let content;

        if (this.props.isFetching) {
            content = <LoadingSection />;
        } else {
            content = (
                <OKCalculationWaffer
                    itemsList={values}
                    outstandedLabel={formatText('contractPayrollLoanStepOne-monthlyInstallment')}
                    outstandedText={formattedInstallment}
                />
            );
        }

        return (
            <div className="contract-payroll-loan-step-one__waffer">
                {content}
            </div>
        );
    }
}

PayrollLoanCalculationCard.propTypes = {
    tin: PropTypes.number.isRequired,
    tae: PropTypes.number.isRequired,
    arrangementFee: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired,
    isFetching: PropTypes.bool,
    arrangementPercentage: PropTypes.number.isRequired,
    installment: PropTypes.object.isRequired,
    taeTooltip: PropTypes.object,
    nodata: PropTypes.bool
};

module.exports = PayrollLoanCalculationCard;
